import {observer} from 'mobx-react';
import {FieldHeader} from 'shared/components/index';
import CustomFieldContentFactory from 'shared/components/CustomFieldContentFactory';


const CustomField = observer(({customField, allowClear = true, errorMessage}) => {
  return (
    <div>
      <FieldHeader
        title={customField.name}
        description={customField.description}
        required={customField.required}
        descriptionClassName='waterloo whitespace-pre-wrap'
      />
      <CustomFieldContentFactory
        customField={customField}
        type={customField.type}
        value={customField.value}
        onChange={(value) => customField.merge({value})}
        allowClear={allowClear}
        errorMessage={errorMessage}
      />
    </div>
  );
});

export default CustomField;
